module.exports = __webpack_public_path__ + "static/media/cart-active.03d43f9d.svg";